import { useMemo } from 'react';

import { useGraphQuery } from '@/hooks/useGraphQuery';
import { GraphQuery, QueryFilter } from '@/types';

interface UseKEVVulnerabilitiesProps {
  search?: string;
  limit?: number;
  page?: number;
  kevFilter?: boolean;
}

export const useKEVVulnerabilities = ({
  search = '',
  limit = 100,
  page = 0,
  kevFilter,
}: UseKEVVulnerabilitiesProps = {}) => {
  const trimmedSearch = search.trim();

  const filters: QueryFilter[] = useMemo(() => {
    const baseFilters: QueryFilter[] = [];

    if (kevFilter !== undefined) {
      baseFilters.push({
        field: 'kev',
        operator: '=',
        value: kevFilter,
      });
    }

    if (trimmedSearch) {
      baseFilters.push({
        field: '',
        operator: 'OR',
        value: [
          {
            field: 'id',
            operator: 'CONTAINS',
            value: trimmedSearch.toUpperCase(),
          },
          { field: 'title', operator: 'CONTAINS', value: trimmedSearch },
          { field: 'data', operator: 'CONTAINS', value: trimmedSearch },
        ],
      });
    }

    return baseFilters;
  }, [trimmedSearch, kevFilter]);

  const query: GraphQuery = useMemo(
    () => ({
      node: {
        labels: ['Vulnerability'],
        filters,
      },
      limit,
      page,
      orderBy: 'created',
      descending: true,
    }),
    [filters, limit, page]
  );

  return useGraphQuery({ query, enabled: true });
};
